import React, { useEffect, useState } from "react";

const TEXT_ROTATE_MS = 7000;
const PHOTO_ROTATE_MS = 7000;

// Secciones solicitadas: Historia, Misión, Visión
const sections = [
  {
    title: "Historia",
    text: `EKine nace de la idea de crear un espacio único para cada persona, sin discriminar por edad ni nivel físico. Que busquen cambiar su estilo de vida o simplemente recuperarse de una lesión, dolor o prevenir lesiones en el deporte. Buscando redefinir el concepto de rehabilitación física y de ejercicio físico, que la terapia activa sea siempre y que el movimiento sea la principal herramienta.`,
  },
  {
    title: "Misión",
    text: `Nuestra misión es ofrecer programas de kinesiología personalizados, reintegro deportivo y entrenamiento físico enfocado en cada persona. Tratamos a cada persona como un individuo diferente, dándole la atención necesaria a cada uno, trabajando de manera integral para ayudarlos a alcanzar su máximo rendimiento y lograr sus objetivos.`,
  },
  {
    title: "Visión",
    text: `Nuestra visión va orientada en 3 pilares fundamentales: equilibrio, disciplina y motivación. Sabiendo que todo tiene que tener un equilibrio porque sin disciplina esto no se logra y nosotros te damos el empuje en la motivación para lograr todo lo que nuestros pacientes se propongan.`,
  },
];

const imgs = [
  { src: "/fotos/IMG_1271.jpg", alt: "Trabajo de fuerza y técnica" },
  { src: "/fotos/IMG_0916.png", alt: "Movilidad y liberación" },
  { src: "/fotos/IMG_5752.jpg", alt: "Trabajo con bandas elásticas" },
  { src: "/fotos/IMG_1272.jpg", alt: "Entrenamiento funcional" },
];

// Pastillas de progreso del texto
function Dots({ count, active, onDotClick }) {
  return (
    <div className="inline-flex items-center rounded-full bg-white/80 backdrop-blur-sm shadow px-3 py-1">
      {Array.from({ length: count }).map((_, i) => (
        <button
          key={i}
          aria-label={`Texto ${i + 1}`}
          onClick={() => onDotClick && onDotClick(i)}
          className={`h-2.5 mx-1 rounded-full transition-all duration-300 ${
            active === i
              ? "w-8 bg-[#06b6fa]"
              : "w-3 bg-[#C7D7FF] hover:bg-[#A9C0FF]"
          }`}
        />
      ))}
    </div>
  );
}

export default function SobreNosotros() {
  const [textIndex, setTextIndex] = useState(0);
  const [photoIndex, setPhotoIndex] = useState(0);

  // Auto-rotación del texto (Historia, Misión, Visión)
  useEffect(() => {
    const id = setTimeout(() => {
      setTextIndex((prev) => (prev + 1) % sections.length);
    }, TEXT_ROTATE_MS);
    return () => clearTimeout(id);
  }, [textIndex]);

  // Auto-rotación fotos
  useEffect(() => {
    const id = setTimeout(() => {
      setPhotoIndex((prev) => (prev + 1) % imgs.length);
    }, PHOTO_ROTATE_MS);
    return () => clearTimeout(id);
  }, [photoIndex]);

  const goNextPhoto = () =>
    setPhotoIndex((prev) => (prev + 1) % imgs.length);

  const goPrevPhoto = () =>
    setPhotoIndex((prev) => (prev - 1 + imgs.length) % imgs.length);

  const activeSection = sections[textIndex];

  return (
    <section className="relative w-full min-h-screen overflow-hidden bg-[#E5E5E5]">
      {/* Fondos suaves */}
      <div className="pointer-events-none absolute -top-32 -right-40 w-80 h-80 rounded-full bg-[#3A6AFF]/20 blur-3xl" />
      <div className="pointer-events-none absolute bottom-[-6rem] left-[-4rem] w-72 h-72 rounded-full bg-fuchsia-400/20 blur-3xl" />

      <div className="relative max-w-7xl mx-auto px-6 md:px-10 lg:px-12 py-20">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-14 items-center">
          {/* TEXTO IZQUIERDA */}
          <div className="max-w-xl">
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-extrabold text-[#0A1440] mb-3">
              Sobre <span className="text-[#00698F]">Nosotros</span>
            </h2>

            {/* Título de sección activa: Historia / Misión / Visión */}
            <h3 className="text-xl md:text-2xl font-semibold text-[#0A1440] mb-4">
              {activeSection.title}
            </h3>

            {/* Texto con transición */}
            <div className="relative">
              {sections.map((section, i) => (
                <p
                  key={section.title}
                  className={`
                    transition-all duration-500 ease-out
                    text-[1.05rem] md:text-lg leading-relaxed md:leading-8 text-[#0A1440]
                    ${
                      textIndex === i
                        ? "opacity-100 translate-y-0 h-auto"
                        : "opacity-0 -translate-y-2 h-0 overflow-hidden"
                    }
                  `}
                >
                  {section.text}
                </p>
              ))}
            </div>

            {/* Pastillas */}
            <div className="mt-6">
              <Dots
                count={sections.length}
                active={textIndex}
                onDotClick={setTextIndex}
              />
            </div>
          </div>

          {/* FOTO DERECHA */}
          <div className="flex justify-center md:justify-end">
            <div className="relative w-full max-w-lg">
              {/* Animación suave al cambiar imagen */}
              <div
                key={photoIndex}
                className="
                  rounded-[20px] overflow-hidden shadow-[0_30px_80px_-40px_rgba(15,23,42,0.45)]
                  bg-white
                  transition-all duration-500 ease-[cubic-bezier(0.4,0.0,0.2,1)]
                  animate-fadeIn
                "
              >
                <img
                  src={imgs[photoIndex].src}
                  alt={imgs[photoIndex].alt}
                  className="w-full h-[360px] md:h-[420px] object-cover"
                />
              </div>

              {/* FLECHAS LATERALES — SOLO DESKTOP */}
              <button
                type="button"
                onClick={goPrevPhoto}
                className="
                  hidden md:flex
                  absolute top-1/2 -translate-y-1/2 -left-12 
                  w-10 h-10 rounded-full bg-white/80 backdrop-blur-xl 
                  border border-white/70 shadow-lg items-center 
                  justify-center text-[#0A1440] hover:bg-white transition
                "
              >
                ‹
              </button>

              <button
                type="button"
                onClick={goNextPhoto}
                className="
                  hidden md:flex
                  absolute top-1/2 -translate-y-1/2 -right-12 
                  w-10 h-10 rounded-full bg-white/80 backdrop-blur-xl 
                  border border-white/70 shadow-lg items-center 
                  justify-center text-[#0A1440] hover:bg-white transition
                "
              >
                ›
              </button>

              {/* FLECHAS INFERIORES — SOLO MÓVIL */}
              <div className="flex md:hidden items-center justify-center gap-6 mt-4">
                <button
                  onClick={goPrevPhoto}
                  className="w-10 h-10 rounded-full bg-white/80 backdrop-blur-xl border border-white/70 shadow-lg flex items-center justify-center text-[#0A1440]"
                >
                  ‹
                </button>

                <button
                  onClick={goNextPhoto}
                  className="w-10 h-10 rounded-full bg-white/80 backdrop-blur-xl border border-white/70 shadow-lg flex items-center justify-center text-[#0A1440]"
                >
                  ›
                </button>
              </div>

              {/* Caption */}
              <p className="mt-3 text-sm text-center text-[#334155]">
                {imgs[photoIndex].alt}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
